import AppRoutes from './Routes';

export default AppRoutes;